import { Button, Form, Input, Modal } from "antd";
import React, { useEffect, useState } from "react";

import Idiachi from "../assets/idiachi.svg";
import Ihoten from "../assets/ihoten.svg";
import Ithoigian from "../assets/ithoigian.svg";

const ModalVAT = (props) => {
  const [vat, setVAT] = useState(null);
  const [form] = Form.useForm();
  const formRef = React.createRef();

  useEffect(() => {
    let dataVAT = JSON.parse(localStorage.getItem("vatTomato"));
    if (dataVAT) {
      setVAT(dataVAT);
      form.setFieldsValue({
        name: dataVAT?.name,
        taxCode: dataVAT?.taxCode,
        address: dataVAT?.address,
      });
    } else {
      form.resetFields();
    }
  }, [props.isModalVisible]);

  const actionFormVAT = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        localStorage.setItem("vatTomato", JSON.stringify(values));
        props.handleCancel();
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  return (
    <div style={{ fontSize: 14 }}>
      <Modal
        className="custom-modal-antd"
        style={{
          maxWidth: "100%",
          margin: 0,
          verticalAlign: "bottom",
          padding: 0,
          maxHeight: "90%",
        }}
        centered={true}
        footer={false}
        closable={true}
        open={props.isModalVisible}
        onCancel={props.handleCancel}
        maskStyle={{ backgroundColor: "rgba(0,0,0, 0.8)" }}
      >
        <Form ref={formRef} form={form} onFinish={actionFormVAT} name="VAT">
          <div>
            <div
              style={{
                padding: "0px 10px 10px 10px",
                fontWeight: 500,
                fontSize: 16,
              }}
            >
              Thông tin xuất hóa đơn
            </div>
            <div
              style={{ padding: "10px 10px 0px 10px", position: "relative" }}
            >
              <div style={css.titleInput}>
                Tên doanh nghiệp/ tên cá nhân
                <span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Ihoten} alt="quyen loi" />
              <Form.Item
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={{ ...css.input, textTransform: "capitalize" }}
                  placeholder="Tên doanh nghiệp/ cá nhân"
                />
              </Form.Item>
            </div>
            <div style={{ padding: "10px 10px 0px 10px" }}>
              <div style={{ marginRight: 5 }}>
                <div style={{ padding: "0px", position: "relative" }}>
                  <div style={css.titleInput}>Mã số thuế</div>
                  <img style={css.iconInput} src={Ithoigian} alt="quyen loi" />
                  <Form.Item
                    name="taxCode"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng chọn và nhập thông tin",
                      },
                      {
                        // required: true,
                        message: "Vui lòng nhập đúng định dạng mã số thuế!",
                        pattern: /^[\d\-\/.\s]{10,}$/
                      }
                    ]}
                    style={css.FormItemsHolder}
                  >
                    <Input
                      autoComplete="off"
                      type={"text"}
                      style={css.input}
                      placeholder="Mã số thuế"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div
              style={{
                padding: "10px 10px 0px 10px",
                position: "relative",
                marginBottom: 20,
              }}
            >
              <div style={css.titleInput}>
                Địa chỉ<span style={{ color: "red" }}>*</span>
              </div>
              <img style={css.iconInput} src={Idiachi} alt="cmnd" />
              <Form.Item
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng chọn và nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  autoComplete="off"
                  style={css.input}
                  placeholder="Địa chỉ"
                />
              </Form.Item>
            </div>
            <div
              style={{
                borderRadius: "16px 16px 0px 0px",
                justifyContent: "center",
                padding: "16px",
                boxShadow: "0px -4px 8px rgba(0, 0, 0, 0.1)",
                width: "100%",
                background: "#ffffff",
              }}
            >
              <Button
                onClick={() => {
                  actionFormVAT();
                }}
                style={{
                  border: "1px solid #009B4B",
                  fontSize: 16,
                  background: "#009B4B",
                  color: "#ffffff",
                  width: "100%",
                  textAlign: "center",
                  borderRadius: 8,
                  padding: 5,
                  fontWeight: 600,
                  height: "fit-content",
                }}
              >
                Cập nhật
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ModalVAT;

const css = {
  input: {
    color: "#3A3A3A",
    zIndex: 1,
    fontSize: 15,
    boxShadow: "none",
    padding: "10px 35px",
    borderRadius: 9,
    width: "100%",
  },
  titleInput: { color: "#646D69", marginBottom: 3 },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  iconInput: {
    width: 20,
    margin: "14px 10px",
    position: "absolute",
    zIndex: 2,
  },
};
